<template>
    <transition appear name="fade">
        <div v-if="chat" class="sc-chat-window opened">
            <ChatHeader v-if="!user.isCoach" :conversation="conversation" :conversations="conversations" :consultation="consultation" />

            <div class="sc-message-list">
                <ChatMessage
                    v-for="(message, i) in messagesArray"
                    :key="i"
                    :last="isLast(i)"
                    :message="message"
                    @modal="openModal"
                    @send="messageStatus"
                    @unread="messageUnread"
                    :unread-notice="unreadMsg ? (message.uuid === unreadMsg.uuid ? true : false) : false"
                    @remove="removeMessage"
                    @edit="editMessage"
                />
            </div>

            <ChatInput v-if="!closeInput" :send="send" :message-to-edit="messagetoEdit" :conversation="conversation" />

            <ChatMessageModalStatus :message="message" :send="send"></ChatMessageModalStatus>

            <ChatMessageModalDelete :message="message" :conversation="conversation"></ChatMessageModalDelete>

            <div v-if="closeInput" class="sc-chat-closed">
                <span>{{ __('Chat is closed') }}</span>
            </div>
        </div>
    </transition>
</template>

<script>
import ChatMessage from './ChatMessage.vue'
import ChatHeader from './ChatHeader.vue'
import ChatInput from './ChatInput.vue'
import ChatMessageModalStatus from './ChatMessageModalStatus.vue'
import ChatMessageModalDelete from './ChatMessageModalDelete.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        ChatHeader,
        ChatMessage,
        ChatInput,
        ChatMessageModalStatus,
        ChatMessageModalDelete
    },
    props: {
        isChatClosed: {
            type: Boolean,
            required: false,
            default: false
        },
        patient: {
            type: Object,
            required: false,
            default: false
        },
        unreadMessagesCount: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            message: null,
            send: false,
            unreadMsg: null,
            messagetoEdit: null
        }
    },
    computed: {
        ...mapGetters({
            chat: 'chat/chat',
            messages: 'chat/messages',
            conversation: 'chat/conversation',
            channels: 'chat/channels'
        }),
        closeInput() {
            return this.isChatClosed || !_.get(this.conversation, 'active', true)
        },
        consultation() {
            return this.chat.data.consultation
        },
        conversations() {
            return this.chat.users
        },
        messagesArray() {
            const messages = this.messages.map(message => {
                if(this.patient.user_id == message.from) {
                    message.user = this.patient.user 
                } else {
                    this.channels.forEach(channel => {
                        if(channel.coach.user.id == message.from) {
                            message.user = channel.coach.user
                        }
                    });
                }

                return message
            })

            return _.orderBy(messages, 'created_at')
        }
    },
    watch: {
        async 'messages.length'() {
            await this.$nextTick()

            this.scrollDown()
            this.send = false
            this.message = this.messagetoEdit = null

            if(this.unreadMessagesCount > 0) {
                var msgs = this.messages.filter((msg) => msg.type === 'incoming')
                this.unreadMsg = msgs.reverse()[this.unreadMessagesCount - 1]

                const $list = $(this.$el).find('.sc-message-list')

                if ($list.length > 0) {
                    $list.animate({ scrollTop: $('.sc-message--unread-notice')[0].offsetTop - 20 }, 0)
                }
            }
        }
    },
    async mounted() {
        var that = this
        
        $(function() {
            $('.item-messages').addClass('active')
            // First we get the viewport height and we multiply it by 1% to get a value for a vh unit
            const vh = window.innerHeight * 0.01
            // Then we set the value in the --vh custom property to the root of the document
            document.documentElement.style.setProperty('--vh', `${vh}px`)
        })

        if (this.user.role === 'coach') {
            if (!this.patient) {
                alert('Patient prop required!')
            }
        }

        await this.initialize(this.patient.user_id)

        await this.fetchAvailableChannels(this.patient.id)

        await this.channels.forEach(channel => {
            this.fetchMessagesChannel(channel.channel_id)
        });

        $(window).on('resize', function () {
            that.changeListHeight()
        })

        $('.chat-toggle').on('click', function () {
            if ($('.panel-wrapper').hasClass('chat-maximized')) {
                $('.panel-wrapper').removeClass('chat-maximized')
            } else {
                $('.panel-wrapper').addClass('chat-maximized')
            }

            setTimeout(() => {
                that.changeListHeight()
            }, 400)
        })

        await this.$nextTick()
    },
    methods: {
        ...mapActions({
            initialize: 'chat/initialize',
            fetchMessages: 'chat/fetchMessages',
            fetchAvailableChannels: 'chat/fetchAvailableChannels',
            fetchMessagesChannel: 'chat/fetchMessagesChannel',
            unreadMessage: 'chat/unreadMessage'
        }),
        openModal(message) {
            this.message = message
            $('#modal-message-status').modal('show')
        },
        isLast(i) {
            return i === this.messages.length - 1
        },
        scrollDown() {
            setTimeout(() => {
                const $list = $(this.$el).find('.sc-message-list')

                if ($list.length > 0) {
                    $list.animate({ scrollTop: $list[0].scrollHeight }, 0)
                }
            }, 250);
        },
        messageStatus(send) {
            this.send = send

            if (this.send) {
                this.message = this.messagetoEdit = null
                this.scrollDown()
            }
        },
        changeListHeight() {
            const appHeight = $(window).height()
            const inputHeight = $('.sc-user-input')[0].offsetHeight
            const chatHeaderHeight = 0
            if($('.sc-header').length > 0) {
            chatHeaderHeight = $('.sc-header')[0].offsetHeight
            }
            const headerHeight = parseInt($('.page-container').css('padding-top'))
            var matrixPanelHeight = 0
            var navTabsHeight = 0
            const messageList = $('.sc-message-list')
            const messageListOuterHeight = messageList.outerHeight()

            if($('.sc-header').length > 0) {
                chatHeaderHeight = $('.sc-header')[0].offsetHeight
            }

            if (this.user.role === 'coach') {
                matrixPanelHeight = $('.matrix-panel')[0].offsetHeight
                navTabsHeight = $('.nav-tabs')[0].offsetHeight
            }

            messageList.outerHeight(
                appHeight - inputHeight - chatHeaderHeight - headerHeight - matrixPanelHeight - navTabsHeight
            )

            if(messageListOuterHeight !== messageList.outerHeight()) {
                messageList.animate({ scrollTop: messageList[0].scrollHeight }, 0)
            }
        },
        messageUnread(message) {
            this.unreadMsg = message
            var msgs = this.messages.filter((msg) => msg.type === 'incoming')
            var msgCount = msgs.reverse().findIndex((el) => el.uuid === message.uuid) + 1

            this.unreadMessage({
                channel_id: this.conversation.channel_id, 
                msg_count: msgCount
            })
        },
        editMessage(message) {
            this.messagetoEdit = message
        },
        removeMessage(message) {
            this.message = message
        }
    }
}
</script>
